var _path, _path2, _path3, _ellipse, _circle, _ellipse2, _ellipse3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateGear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.5 127.5C141 124.5 128.5 141.5 128.5 154.5C128.5 167.5 134.297 177.557 131.5 190C128.606 202.87 124.127 221 93.4996 221C62.4995 221 42.5532 186.393 50.9995 169.5C60.4996 150.5 71.6288 152.177 74.9373 131C78.9993 105 68.4563 83.809 74.9373 70.0001C86.4361 45.5003 112.12 47.4662 138.5 55.5C165.1 63.6009 176.984 70.5629 186.5 77C220.5 100 241.313 118.254 221.5 127.5C206.5 134.5 196 130.5 168.5 127.5Z",
    fill: "url(#paint0_linear_28236_154901)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.499 56.9998C146.261 69.2372 156.499 91.8016 126.5 103.5C114.5 108.179 108.799 101 85.5 101C66.1202 101 51.0001 110 46.0001 133C39.7771 161.626 72.1804 186.469 88.4995 195C110.5 206.5 136.597 213.784 165.499 201C189 190.605 200.492 175.959 208.499 159.5C213.499 149.222 217.73 125 214.5 101C212.128 83.378 212.119 67.8956 198.499 49.4395C185.999 32.5 165.499 31.4993 152.499 56.9998Z",
    fill: "url(#paint1_linear_28236_154901)",
    fillOpacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.853 173.498C217.733 176.964 215.486 185.17 213.569 194.986C208.016 223.405 174.009 206.076 176.092 187.361C177.546 174.29 186.595 169.188 203.853 173.498Z",
    fill: "url(#paint2_linear_28236_154901)",
    fillOpacity: 0.15
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.1242,
    cy: 114.346,
    rx: 10.4107,
    ry: 12.4929,
    transform: "rotate(20.4825 31.1242 114.346)",
    fill: "url(#paint3_linear_28236_154901)",
    fillOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 160.94,
    r: 5,
    fill: "url(#paint4_linear_28236_154901)",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.641,
    cy: 24.3783,
    rx: 7.42109,
    ry: 10.3895,
    transform: "rotate(72.8289 170.641 24.3783)",
    fill: "url(#paint5_linear_28236_154901)",
    fillOpacity: 0.07
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.87,
    cy: 5.7584,
    rx: 4.20707,
    ry: 5.8899,
    transform: "rotate(72.8289 163.87 5.7584)",
    fill: "url(#paint6_linear_28236_154901)",
    fillOpacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132 172.917C154.828 172.917 175.917 151.828 175.917 129C175.917 106.172 154.828 84.7549 132 84.7549C109.172 84.7549 88.0833 106.172 88.0833 129C88.0833 151.828 109.172 172.917 132 172.917ZM132 180.667C160.535 180.667 183.667 157.535 183.667 129C183.667 100.465 160.535 77.3333 132 77.3333C103.465 77.3333 80.3333 100.465 80.3333 129C80.3333 157.535 103.465 180.667 132 180.667Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.984 72.0964C126.474 69.1555 129.019 67 132 67C134.981 67 137.526 69.1555 138.016 72.0964L139.75 82.5H124.25L125.984 72.0964Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.984 185.904C126.474 188.845 129.019 191 132 191C134.981 191 137.526 188.845 138.016 185.904L139.75 175.5H124.25L125.984 185.904Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0964 135.016C72.1555 134.526 70 131.981 70 129C70 126.019 72.1555 123.474 75.0964 122.984L85.5 121.25V136.75L75.0964 135.016Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.904 135.016C191.845 134.526 194 131.981 194 129C194 126.019 191.845 123.474 188.904 122.984L178.5 121.25V136.75L188.904 135.016Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.365 84.7549C99.3191 81.963 100.445 78.8241 103.027 77.3333C105.609 75.8426 108.89 76.4371 110.785 78.7389L117.489 86.8817L104.065 94.6317L100.365 84.7549Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.269 183.315C159.164 185.617 162.445 186.211 165.027 184.72C167.609 183.23 168.735 180.091 167.689 177.299L163.989 167.422L150.565 175.172L157.269 183.315Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7549 164.689C84.963 165.735 81.8241 164.609 80.3333 162.027C78.8426 159.445 79.4371 156.164 81.7389 154.269L89.8817 147.565L97.6317 160.989L87.7549 164.689Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M186.315 107.785C188.617 105.89 189.211 102.609 187.72 100.027C186.23 97.4449 183.091 96.3191 180.299 97.365L170.422 101.065L178.172 114.489L186.315 107.785Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7389 107.783C79.4371 105.888 78.8426 102.607 80.3333 100.025C81.8241 97.4427 84.963 96.3168 87.7549 97.3628L97.6317 101.063L89.8817 114.486L81.7389 107.783Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.299 164.687C183.091 165.733 186.23 164.607 187.72 162.025C189.211 159.443 188.617 156.161 186.315 154.266L178.172 147.563L170.422 160.986L180.299 164.687Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.785 183.313C108.89 185.615 105.609 186.209 103.027 184.718C100.445 183.228 99.3191 180.089 100.365 177.297L104.065 167.42L117.489 175.17L110.785 183.313Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M167.689 84.7527C168.735 81.9608 167.609 78.8218 165.027 77.3311C162.445 75.8404 159.164 76.4349 157.269 78.7367L150.565 86.8795L163.989 94.6295L167.689 84.7527Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132 136.75C136.28 136.75 139.75 133.28 139.75 129C139.75 124.72 136.28 121.25 132 121.25C127.72 121.25 124.25 124.72 124.25 129C124.25 133.28 127.72 136.75 132 136.75ZM132 144.5C140.56 144.5 147.5 137.56 147.5 129C147.5 120.44 140.56 113.5 132 113.5C123.44 113.5 116.5 120.44 116.5 129C116.5 137.56 123.44 144.5 132 144.5Z",
    fill: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.125 116.083V82.5H135.875V116.083H128.125Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5934 150.418L120.997 131.005L125.477 137.329L98.0734 156.742L93.5934 150.418Z",
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.977 150.418L144.573 131.005L140.093 137.329L167.497 156.742L171.977 150.418Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28236_154901",
    x1: 132.712,
    y1: 211.948,
    x2: 52.8337,
    y2: 50.4212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28236_154901",
    x1: 124.353,
    y1: 198.719,
    x2: 42.1052,
    y2: 41.0404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28236_154901",
    x1: 194.111,
    y1: 207.987,
    x2: 176.067,
    y2: 172.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28236_154901",
    x1: 30.3826,
    y1: 125.516,
    x2: 17.1708,
    y2: 104.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28236_154901",
    x1: 234.644,
    y1: 165.411,
    x2: 229.823,
    y2: 156.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_28236_154901",
    x1: 170.113,
    y1: 33.6673,
    x2: 158.476,
    y2: 17.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_28236_154901",
    x1: 163.57,
    y1: 11.0244,
    x2: 156.973,
    y2: 1.98371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateGear);
export default __webpack_public_path__ + "static/media/emptyStateGear.3dcac8f7.svg";
export { ForwardRef as ReactComponent };